module.exports = __webpack_public_path__ + "img/image29.1b1d5189.png";